import ReactDOM from "react-dom";
import Container from "./container.js";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
import "../../../../shared/styles/linkStyles.css";
import "../../../../shared/styles/buttonStyles.css";
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(Container(), document.body.querySelector("#container"));
